import { Dialog, TextInput } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../components/toast/Toast';
import { useUpdateFileRecords } from '../../../queries/use-update-file-records';
import { FileRecordNew } from '../../../types/file-record';

type LinkReplaceConfirmProps = {
    fileRecord: FileRecordNew;
    onClose: () => void;
};

function LinkReplaceConfirm({ fileRecord, onClose }: LinkReplaceConfirmProps): JSX.Element {
    const [link, setLink] = useState(fileRecord.link as string);
    const [linkError, setLinkError] = useState('');

    const updateRecordQuery = useUpdateFileRecords();
    const expression = '^(http|https)://';
    const re = new RegExp(expression);

    function handleLinkChange(value: string): void {
        setLinkError('');
        setLink(value);
    }

    function replaceLink(): void {
        if (link === '') {
            setLinkError('A link is required.');
            toastNotification('error', 'Unable to update link record!');
            return;
        }

        if (re.test(link) === false) {
            setLinkError('Links must start with http:// or https:// .');
            toastNotification('error', 'Unable to update link record!');
            return;
        }

        updateRecordQuery.mutate([{ id: fileRecord.id, fields: { link } }], {
            onSuccess: () => {
                onClose();
                toastNotification('success', 'Link record updated!');
            },
        });
    }

    return (
        <Dialog
            onClose={onClose}
            isOpen={true}
            primaryAction="Replace"
            secondaryAction="Cancel"
            description="Do you want to replace this link? Any worksheets / other schedules that use this file will no longer be reviewed."
            title="Replace Link"
            type="error"
            onPrimaryActionClick={replaceLink}
            onSecondaryActionClick={onClose}
            isLoading={updateRecordQuery.isLoading}
        >
            <div className="pb-4">
                <div className="pr-6">
                    <TextInput
                        defaultValue={fileRecord.link || undefined}
                        title="Link"
                        autoFocus
                        onChange={handleLinkChange}
                        errorMessage={linkError}
                    />
                </div>
            </div>
        </Dialog>
    );
}
export default LinkReplaceConfirm;
